import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-screen-2xl mx-auto">
          <Link to="/" className="flex items-center gap-2 group" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg group-hover:bg-primary-600 transition-colors">
              <i className="ri-book-open-line text-xl text-white"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-950 whitespace-nowrap">
              爱漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/' ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="flex items-center gap-1 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                分类浏览
                <i className="ri-arrow-down-s-line text-base"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-2 grid grid-cols-2 gap-1 min-w-[280px]">
                  {categories.map((cat) => (
                    <button
                      key={cat.id}
                      onClick={() => handleCategoryClick(cat.slug)}
                      className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer text-left"
                    >
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className={`${cat.icon} text-base`}></i>
                      </div>
                      {cat.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about' ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
              <i className="ri-search-line text-lg"></i>
            </button>
            <button className="px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              开始阅读
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50 py-4">
            <div className="flex flex-col gap-1 px-2">
              <Link
                to="/"
                className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
              >
                首页
              </Link>
              <div className="px-3 py-2.5 text-sm font-medium text-foreground-500">分类浏览</div>
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => handleCategoryClick(cat.slug)}
                  className="flex items-center gap-2 px-5 py-2 rounded-md text-sm text-foreground-600 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  {cat.name}
                </button>
              ))}
              <Link
                to="/about"
                className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
              <button className="mt-2 mx-3 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors cursor-pointer">
                开始阅读
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}